import IllustratorLogin from "../../Assets/Illustrator-login.png";
import { FaEnvelope, FaLock, FaKey } from "react-icons/fa";
import { motion } from "framer-motion";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {VerifyMfaOtpForEmail, ResetPasswordAfterMfa} from "../../Services/LoginService"

const ForgotPassword = () => {
  const navigate = useNavigate();

  const [step, setStep] = useState(1); // 1=email, 2=otp, 3=reset

  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

 const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");
  setSuccess("");
  setLoading(true);

  try {
    // Send OTP
    if (step === 1) {
      if (!email) {
        setError("Please enter your registered email address.");
        return;
      }

      // If you already have Send OTP API, call it here
      setSuccess("OTP has been sent to your email.");
      setStep(2);
    }

    //Verify OTP
    else if (step === 2) {
      if (!otp) {
        setError("Please enter OTP.");
        return;
      }

      const res = await VerifyMfaOtpForEmail({
        email: email,
        otp: otp,
      });

      if (res.status === "Success") {
        setSuccess(res.message);
        setStep(3);
      } else {
        setError(res.message || "OTP verification failed.");
      }
    }

    //Reset Password
    else if (step === 3) {
      if (!newPassword || !confirmPassword) {
        setError("Please fill all password fields.");
        return;
      }

      if (newPassword !== confirmPassword) {
        setError("Passwords do not match.");
        return;
      }

      const res = await ResetPasswordAfterMfa({
        email: email,
        password: newPassword,
      });

      if (res.status === "Success") {
        setSuccess(res.message);

        setTimeout(() => {
          navigate("/");
        }, 2000);
      } else {
        setError(res.message || "Password reset failed.");
      }
    }
  } catch (err) {
    setError(
      err.response?.data?.message ||
        err.response?.data?.Message ||
        "Something went wrong. Please try again."
    );
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="min-h-screen flex bg-gradient-to-br from-blue-50 via-blue-100 to-white text-gray-900 overflow-hidden">
      {/* LEFT ILLUSTRATION */}
      <motion.div
        initial={{ x: 80, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 1 }}
        className="hidden md:flex flex-1 items-center justify-center p-10 bg-gradient-to-br from-[#004687] to-[#007BFF] text-white"
      >
        <div className="max-w-md text-center space-y-4">
          <h2 className="text-3xl font-bold">Forgot your password?</h2>
          <p className="text-blue-100 text-sm">
            No worries! Enter your registered email and we’ll help you reset it.
          </p>
          <img
            src={IllustratorLogin}
            alt="Forgot Password"
            className="w-[500px] h-[400px] mx-auto mt-6 object-contain"
          />
        </div>
      </motion.div>

      {/* RIGHT FORM */}
      <motion.div
        initial={{ x: -80, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8 }}
        className="flex-1 flex items-center justify-center px-8 md:px-16 bg-gradient-to-br from-[#E8F1FF] via-[#F8FBFF] to-[#D6E9FF]"
      >
        <div className="w-full max-w-md rounded-3xl shadow-xl p-10 bg-white/80 backdrop-blur-xl border border-blue-100">
          {/* HEADER */}
          <div className="text-center mb-8">
            <img
              src="https://www.vrsamadhantech.com/images/logo_home.png"
              alt="Logo"
              className="w-24 mx-auto mb-3"
            />
            <h2 className="text-3xl font-bold text-[#004687]">
              Forgot Password
            </h2>
            <p className="text-gray-500 text-sm mt-2">
              Secure account recovery
            </p>
          </div>

          {/* FORM */}
          <form className="space-y-5" onSubmit={handleSubmit}>
            {/* EMAIL (Step 1 & 2 only) */}
            {step !== 3 && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Email Address
                </label>
                <div className="relative">
                  <FaEnvelope className="absolute left-3 top-3.5 text-gray-400" />
                  <input
                    type="email"
                    value={email}
                    disabled={step !== 1}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@example.com"
                    className="w-full pl-10 pr-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
            )}

            {/* OTP (Step 2 only) */}
            {step === 2 && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  OTP
                </label>
                <div className="relative">
                  <FaKey className="absolute left-3 top-3.5 text-gray-400" />
                  <input
                    type="text"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    placeholder="Enter OTP"
                    className="w-full pl-10 pr-4 py-2.5 border rounded-lg"
                  />
                </div>
              </div>
            )}

            {/* NEW PASSWORD (Step 3 only) */}
            {step === 3 && (
              <>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    New Password
                  </label>
                  <div className="relative">
                    <FaLock className="absolute left-3 top-3.5 text-gray-400" />
                    <input
                      type="password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      placeholder="New Password"
                      className="w-full pl-10 pr-4 py-2.5 border rounded-lg"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Confirm Password
                  </label>
                  <div className="relative">
                    <FaLock className="absolute left-3 top-3.5 text-gray-400" />
                    <input
                      type="password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      placeholder="Confirm Password"
                      className="w-full pl-10 pr-4 py-2.5 border rounded-lg"
                    />
                  </div>
                </div>
              </>
            )}
            {/* MESSAGES */}
            {error && (
              <p className="text-red-500 text-sm text-center">{error}</p>
            )}
            {success && (
              <p className="text-green-600 text-sm text-center">{success}</p>
            )}

            {/* BUTTON */}
            <motion.button
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              disabled={loading}
              className="w-full bg-gradient-to-r from-[#004687] to-[#007BFF] text-white py-2.5 rounded-lg font-semibold"
            >
              {loading
                ? "Processing..."
                : step === 1
                ? "Send OTP"
                : step === 2
                ? "Verify OTP"
                : "Reset Password"}
            </motion.button>
          </form>

          {/* FOOTER */}
          <p className="text-center text-gray-500 text-xs mt-6">
            Remember your password?{" "}
            <span
              onClick={() => navigate("/")}
              className="text-blue-600 cursor-pointer hover:underline"
            >
              Login here
            </span>
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default ForgotPassword;
